<template>
  <article class="reply-box media note-editor">
    <div class="media-content">
      <o-field label="">
        <o-input v-model="email.to" placeholder="To" />
      </o-field>
      <o-field label="">
        <o-input v-model="email.subject" placeholder="Subject" />
      </o-field>

      <div class="field">
        <b-quill v-model="email.message" />
      </div>

      <nav class="level thread-level">
        <div class="level-left subscribers-multiselect-wrapper"></div>

        <div class="level-right">
          <div class="level-item">
            <button
              v-submit="submitting"
              class="button is-red is-danger button-danger"
              @click.prevent="handle('cancel')"
            >
              Cancel
            </button>
          </div>

          <div class="level-item">
            <button
              v-submit="submitting"
              class="button is-dark"
              @click.prevent="handle('create')"
            >
              Send
            </button>
          </div>
        </div>
      </nav>
    </div>
  </article>
</template>

<script>

export default {
  data() {
    return {
      email: {
        message: "",
        subject: "",
        to: "user@email.com",
      },
      submitting: false,
    }
  },
  methods: {
    handle(type) {
      switch (type) {
        case "cancel":
          this.$emit("cancel")
          break

        default:
          break
      }
    },
  },
  props: ["message"],
}
</script>

<style>
</style>